export function videoInline() {
  const items = document.querySelectorAll("video")

  items.forEach((item) => {
    item.setAttribute("playsinline", true)
  })
}
